import { FormattedMessage } from 'react-intl';
import { PoolSelect, SelectOption, useFilter } from '@synergy/components';
import { ReactNode } from 'react';
import { UserStatus } from '@synergy/models';

import { getUserStatusTranslationId } from '../../utils/get-user-status-translation-id';

export const UserStatusFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (status?: UserStatus) => {
        filter.delete('userStatus');
        if (status) {
            filter.set('userStatus', status);
        }
        updateFilter(filter);
    };

    const getDisplayValue = (userStatus: unknown): ReactNode => {
        if (typeof userStatus !== 'string') {
            return '';
        }

        return <FormattedMessage id={getUserStatusTranslationId(userStatus as UserStatus)} />;
    };

    registerFilterMap('userStatus', getDisplayValue);

    const options = Object.values(UserStatus)
        .filter(
            status => status !== UserStatus.Locked && status !== UserStatus.ShopAdmin && status !== UserStatus.ShopUser
        )
        .map<SelectOption>(userStatus => {
            return {
                value: userStatus,
                displayValue: <FormattedMessage id={getUserStatusTranslationId(userStatus)} />,
            };
        });
    options.unshift({
        value: 'undefined',
        displayValue: <FormattedMessage id="app.filter.showAllUser" />,
    });

    return (
        <PoolSelect
            styleType="simple"
            variant="standard"
            disallowDefaultValue={true}
            displayEmpty={true}
            name="userStatus"
            value={filter.get('userStatus')}
            onValueChange={onSelected}
            noSorting={true}
            options={options}
        />
    );
};
